"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jul 20 2018
 */

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");

var Currency_1 = require("../../currency/model/Currency");
/**
 * <p>
 *     Supplier of some {@link Product internal product}. We divide suppliers on external/internal, and active/inactive.
 *     Suppliers which are suppose to be part of consignment sales only, are distinguished by {@link Supplier.consignmentSale}.
 *     There may be special rules within an application for such suppliers.
 * </p>
 *
 * @author RV
 * @author JMe
 */


var Supplier =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Supplier, _DomainObject_1$Domai);

  /**
   * @param id
   * @param externalId the external id, may be compound from multiple external attributes
   * @param name
   * @param registrationNumber the company identification number
   * @param currencyId the default currency of supplier
   * @param active the flag whether supplier is active or not
   * @param external the flag indicating whether supplier is external (it is not part of the company)
   * @param consignmentSale denotes whether supplier is part of consignment sales (true if yes, false otherwise)
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function Supplier(id, externalId, name, registrationNumber, currencyId, active, external, consignmentSale, processed) {
    var _this;

    _classCallCheck(this, Supplier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Supplier).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    _this.registrationNumber = registrationNumber;
    _this.currencyId = currencyId;
    _this.active = active;
    _this.external = external;
    _this.consignmentSale = consignmentSale;
    _this.processed = processed;
    return _this;
  }
  /**
   * Parse parts of supplier external ID.
   * @param externalId supplier external ID
   */


  _createClass(Supplier, null, [{
    key: "parseSupplierExternalId",
    value: function parseSupplierExternalId(externalId) {
      var parts = externalId.split(utils_1.Utils.EXTERNAL_ID_SEPARATOR);

      if (utils_1.Utils.isValueMissing(parts) || parts.length !== 3) {
        throw new Error("Invalid supplier external id ".concat(externalId));
      }

      return {
        supplierId: parts[0],
        supplierDepartmentId: Number(parts[1]),
        commercialContractId: parts[2]
      };
    }
  }]);

  return Supplier;
}(DomainObject_1.DomainObject);

exports.Supplier = Supplier;
/**
 * Lookup for all suppliers
 */

Supplier.SUPPLIERS_LOOKUP = CodebookLookupSequence_1.CodebookLookupSequence.Supplier; // tslint:disable-next-line:member-ordering

Supplier.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Supplier.name);
  return {
    id: builder.id('id'),
    externalId: builder.id('externalId'),
    name: builder.str('name'),
    registrationNumber: builder.opt(builder.str('registrationNumber')),
    currencyId: builder.lookup('currencyId', Currency_1.Currency.CURRENCIES_LOOKUP),
    active: builder.bool('active'),
    external: builder.bool('external'),
    consignmentSale: builder.bool('consignmentSale'),
    processed: builder.bool('processed')
  };
}();